// extracted by mini-css-extract-plugin
export default {"wrapper":"adminTabList_wrapper__m3C8K"};